<script>
export default {
  name: 'Dropdown',
  components: {
    Icon: () => import('@/components/general/Icon')
  },

  props: {
    classes: {
      type: String,
      default: null
    },

    icon: {
      type: String,
      default: null
    },

    text: {
      type: String,
      default: null
    },

    iconSize: {
      type: String,
      default: null
    },

    title: {
      type: String,
      default: null
    },

    right: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isOpen: false,
      popupStyle: null
    }
  },

  beforeDestroy () {
    this.removeScrollListener()
  },

  methods: {
    toggleMenu () {
      if (this.disabled === true) {
        return
      }

      if (this.isOpen) {
        this.closeMenu()
      } else {
        this.openMenu()
      }
    },

    openMenu () {
      this.isOpen = true

      this.$nextTick(() => {
        this.positionPopup()
        this.addScrollListener()
      })
    },

    closeMenu () {
      this.isOpen = false
      this.removeScrollListener()
    },

    outside () {
      if (this.isOpen) {
        this.closeMenu()
      }
    },

    addScrollListener () {
      window.addEventListener('scroll', this.handleScroll, {
        passive: true,
        capture: true
      })

      window.addEventListener('resize', this.closeMenu, { passive: true })
    },

    removeScrollListener () {
      window.removeEventListener('scroll', this.handleScroll, { capture: true })
      window.removeEventListener('resize', this.closeMenu)
    },

    handleScroll () {
      this.closeMenu()
    },

    positionPopup () {
      const trigger = this.$refs.trigger
      const popup = this.$refs.popup

      if (!trigger || !popup) return

      const viewportHeight = window.innerHeight
      const viewportWidth = window.innerWidth
      const margin = 8

      const maxViewportWidth = viewportWidth - margin * 2

      popup.style.maxWidth = `${maxViewportWidth}px`

      const triggerRect = trigger.getBoundingClientRect()
      const popupHeight = popup.offsetHeight
      const popupWidth = popup.offsetWidth

      const spaceBelow = viewportHeight - triggerRect.bottom
      const spaceAbove = triggerRect.top

      const placeAbove = spaceBelow < popupHeight + margin && spaceAbove > spaceBelow

      let top
      let left

      if (placeAbove) {
        top = Math.max(margin, triggerRect.top - popupHeight - margin)
      } else {
        top = triggerRect.bottom + margin
      }

      if (this.right) {
        left = triggerRect.right - popupWidth
      } else {
        left = triggerRect.left
      }

      const maxLeft = viewportWidth - popupWidth - margin

      if (left > maxLeft) left = maxLeft
      if (left < margin) left = margin

      this.popupStyle = {
        position: 'fixed',
        top: `${top}px`,
        left: `${left}px`,
        maxWidth: `${maxViewportWidth}px`
      }
    },

    isDisabledClass () {
      if (this.disabled === true) {
        return 'is-disabled'
      }

      return ''
    }
  }
}
</script>

<template>
  <div
    v-click-outside="outside"
    class="dropdown"
  >
    <a
      ref="trigger"
      href="#"
      class="dropdown-link"
      :class="[classes, isDisabledClass()]"
      @click.prevent="toggleMenu"
    >
      <Icon
        v-if="icon"
        :name="icon"
        wrapper
        :size="iconSize"
      />
      <span
        v-if="text"
        class="text"
      >{{ text }}</span>
    </a>
    <Transition name="fadeInUp">
      <div
        v-if="isOpen"
        ref="popup"
        class="dropdown-content"
        :class="{ 'open-right': right }"
        :style="popupStyle"
      >
        <div
          v-if="title"
          class="dropdown-content-title"
        >
          <Icon
            v-if="icon"
            :name="icon"
            wrapper
            size="medium"
          />
          <span class="text">{{ title }}</span>
        </div>
        <div class="dropdown-content-list">
          <slot />
        </div>
      </div>
    </Transition>
  </div>
</template>

<style src="@/assets/styles/themes/default/dropdown.css"></style>
